unable to read source [project]/node_modules/.pnpm/demonym@1.0.0/node_modules/demonym/src/core.ts